var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2"},[_c('v-row',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-row',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.body)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }